/* provecho™ by Folks — ficha de producto */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function group(intStr, sep) {
    return String(intStr).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents, fmt) {
    var n = Math.abs(cents) / 100;
    var parts = n.toFixed(2).split('.');
    var out;
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) out = group(Math.round(n), '.');
    else if (fmt.indexOf('amount_no_decimals_with_apostrophe_separator') !== -1) out = group(Math.round(n), "'");
    else if (fmt.indexOf('amount_with_comma_separator') !== -1) out = group(parts[0], '.') + ',' + parts[1];
    else if (fmt.indexOf('amount_with_apostrophe_separator') !== -1) out = group(parts[0], "'") + '.' + parts[1];
    else if (fmt.indexOf('amount_no_decimals') !== -1) out = group(Math.round(n), ',');
    else out = group(parts[0], ',') + '.' + parts[1];
    if (cents < 0) out = '-' + out;
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, out);
  }

  function readJSON(root, sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function init(root) {
    if (root.__pv) return;
    root.__pv = true;
    root.classList.add('pv-js');

    var variants = readJSON(root, '[data-pv-variants]', []);
    var moneyFmt = readJSON(root, '[data-pv-money]', '${{amount}}');
    var startId = root.getAttribute('data-variant');
    var selected = variants.filter(function (v) { return String(v.id) === startId; })[0] || variants[0];
    var chosen = selected ? selected.options.slice() : [];
    var qty = 1;
    var adding = false;

    function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function setText(sel, text) { all(sel).forEach(function (el) { el.textContent = text; }); }
    function money(c) { return formatMoney(c, moneyFmt); }

    /* ── Galería ── */
    var track = root.querySelector('[data-pv-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-pv-slide]')) : [];
    var thumbsWrap = root.querySelector('[data-pv-thumbs]');
    var counter = root.querySelector('[data-pv-count]');
    var thumbs = [];
    var active = 0;

    slides.forEach(function (slide, i) {
      var src = slide.getAttribute('data-thumb');
      if (!thumbsWrap || !src) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pv-gal__thumb' + (slide.hasAttribute('data-video') ? ' is-video' : '');
      b.setAttribute('aria-label', (slide.hasAttribute('data-video') ? 'Ver video' : 'Ver foto ' + (i + 1)));
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      b.appendChild(img);
      b.addEventListener('click', function () { goTo(i); });
      thumbsWrap.appendChild(b);
      thumbs.push(b);
    });
    if (slides.length < 2 && thumbsWrap) thumbsWrap.hidden = true;

    function mark(i) {
      active = i;
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-on', i === j);
        if (i === j) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (counter && slides.length > 1) counter.textContent = (i + 1) + ' / ' + slides.length;
      var t = thumbs[i];
      if (t && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        thumbsWrap.scrollTo({ left: t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    function goTo(i) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    if (track) {
      var scrollTimer = 0;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== active) mark(Math.max(0, Math.min(slides.length - 1, i)));
        }, 60);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      });
      var prev = root.querySelector('[data-pv-prev]');
      var next = root.querySelector('[data-pv-next]');
      if (slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      }
      if (prev) prev.addEventListener('click', function () { goTo(active - 1); });
      if (next) next.addEventListener('click', function () { goTo(active + 1); });
      mark(0);
    }

    /* ── Variantes ── */
    function findVariant(opts, idx, val) {
      var exact = variants.filter(function (v) {
        return v.options.every(function (o, k) { return o === opts[k]; });
      })[0];
      if (exact) return exact;
      var avail = variants.filter(function (v) { return v.options[idx] === val && v.available; })[0];
      return avail || variants.filter(function (v) { return v.options[idx] === val; })[0];
    }

    function paint(v, fromUser) {
      if (!v) return;
      selected = v;
      chosen = v.options.slice();

      all('[data-pv-variant-input]').forEach(function (input) { input.value = v.id; });
      setText('[data-pv-price]', money(v.price));
      setText('[data-pv-cuota]', money(Math.floor(v.price / 12)));
      setText('[data-pv-variant-title]', v.title);

      var hasCompare = v.compare > v.price;
      all('[data-pv-compare]').forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = money(v.compare);
      });
      all('[data-pv-off]').forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = '−' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
      });

      all('[data-pv-buy]').forEach(function (btn) {
        btn.disabled = !v.available;
        var label = btn.querySelector('[data-pv-buy-label]');
        var inDock = !!btn.closest('[data-pv-dock]');
        if (label) label.textContent = v.available ? (inDock ? 'Comprar' : 'Comprar ahora') : 'Agotado';
      });
      all('[data-pv-atc]').forEach(function (btn) { btn.disabled = !v.available; });

      var stock = root.querySelector('[data-pv-stock]');
      if (stock) {
        var max = parseInt(stock.getAttribute('data-max'), 10) || 20;
        var stockOn = v.available && v.tracked && v.inv > 0 && v.inv <= max;
        stock.hidden = !stockOn;
        if (stockOn) {
          var stockText = stock.querySelector('[data-pv-stock-text]');
          var stockBar = stock.querySelector('[data-pv-stock-bar]');
          if (stockText) stockText.innerHTML = v.inv === 1 ? 'Queda <b>1</b> unidad' : 'Quedan <b>' + v.inv + '</b> unidades';
          if (stockBar) stockBar.style.width = Math.min(100, Math.max(8, Math.round(v.inv * 100 / max))) + '%';
        }
      }

      var avail = root.querySelector('[data-pv-avail]');
      var availLabel = root.querySelector('[data-pv-avail-label]');
      if (avail && availLabel) {
        avail.classList.remove('pv-avail--in', 'pv-avail--low', 'pv-avail--out');
        if (!v.available) {
          avail.classList.add('pv-avail--out');
          availLabel.textContent = 'Agotado por ahora';
        } else if (v.tracked && v.inv > 0 && v.inv < 5) {
          avail.classList.add('pv-avail--low');
          availLabel.textContent = v.inv === 1 ? 'Queda la última' : 'Quedan ' + v.inv;
        } else {
          avail.classList.add('pv-avail--in');
          availLabel.textContent = 'En stock · sale hoy';
        }
      }

      all('[data-pv-opt]').forEach(function (btn) {
        var idx = +btn.getAttribute('data-pv-opt');
        var on = chosen[idx] === btn.getAttribute('data-value');
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      all('[data-pv-opt-label]').forEach(function (el) {
        el.textContent = chosen[+el.getAttribute('data-pv-opt-label')] || '';
      });

      if (fromUser && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (fromUser && v.media) {
        var k = -1;
        slides.forEach(function (s, i) { if (k < 0 && s.getAttribute('data-media-id') === String(v.media)) k = i; });
        if (k >= 0) goTo(k);
      }
    }

    all('[data-pv-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = +btn.getAttribute('data-pv-opt');
        var val = btn.getAttribute('data-value');
        var next = chosen.slice();
        next[idx] = val;
        paint(findVariant(next, idx, val), true);
      });
    });

    /* ── Cantidad ── */
    function setQty(n) {
      qty = Math.max(1, Math.min(99, n));
      setText('[data-pv-qty-num]', String(qty));
      all('[data-pv-qty-input]').forEach(function (input) { input.value = qty; });
    }
    var minus = root.querySelector('[data-pv-qty-minus]');
    var plus = root.querySelector('[data-pv-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    /* ── Carrito ── */
    function add(form, checkout) {
      if (adding) return;
      adding = true;
      var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
      buttons.forEach(function (b) { b.disabled = true; });
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            window.alert(res.description || 'No pudimos agregarlo al carrito.');
            return;
          }
          if (checkout) {
            window.location.href = '/checkout';
            return;
          }
          if (window.FolksCart && window.FolksCart._refreshFromAPI) {
            window.FolksCart._refreshFromAPI().then(function () { window.FolksCart.open(); });
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          buttons.forEach(function (b) { b.disabled = false; });
          adding = false;
          if (selected) paint(selected, false);
        });
    }
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      e.preventDefault();
      var submitter = e.submitter;
      add(form, !!(submitter && submitter.name === 'checkout'));
    }, true);

    /* ── Barra fija ── */
    var dock = root.querySelector('[data-pv-dock]');
    var actions = root.querySelector('[data-pv-actions]');
    if (dock && actions && 'IntersectionObserver' in window) {
      var close = root.querySelector('.pv-close');
      var footer = document.querySelector('footer, .footer, #shopify-section-footer');
      var state = { actionsVisible: true, actionsAbove: false, closeVisible: false, footerVisible: false };
      var update = function () {
        var on = !state.actionsVisible && state.actionsAbove && !state.closeVisible && !state.footerVisible;
        dock.classList.toggle('is-on', on);
        dock.setAttribute('aria-hidden', on ? 'false' : 'true');
        all('[data-pv-dock] button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      };
      var dio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === actions) {
            state.actionsVisible = en.isIntersecting;
            state.actionsAbove = !en.isIntersecting && en.boundingClientRect.top < 0;
          } else if (en.target === close) {
            state.closeVisible = en.isIntersecting;
          } else {
            state.footerVisible = en.isIntersecting;
          }
        });
        update();
      }, { threshold: 0 });
      [actions, close, footer].forEach(function (el) { if (el) dio.observe(el); });
    }

    /* ── Aparición ── */
    var reveals = all('[data-pv-reveal]');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          el.classList.add('is-in');
          io.unobserve(el);
          setTimeout(function () { el.style.setProperty('--d', '0ms'); }, 1400);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* ── Videos ── */
    var videos = all('video');
    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduce) {
        v.removeAttribute('autoplay');
        v.pause();
      }
    });
    if (!reduce && 'IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { vio.observe(v); });
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pv-root]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
